// Troika text (DXF/MTEXT) — GLOBAL GPU SDF kapatma.
//
// Bazı GPU/driver kombinasyonlarında (özellikle yazılım-render/SwiftShader veya
// WebGL1 sınırlı contextlerde) `ANGLE_instanced_arrays` extension'ı yok →
// troika'nın kullandığı webgl-sdf-generator "ANGLE_instanced_arrays not supported"
// throw ediyor (CRA dev overlay'de "Uncaught runtime errors"). Troika normalde JS
// worker path'ine düşse de bu throw + gecikme yaşanıyor.
//
// Çözüm: her troika Text örneğini sync() öncesi `gpuAccelerateSDF=false` ile JS
// path'e zorla. Prototype.sync sarmalı → oluşturma yerinden bağımsız TÜM text'leri
// kapsar (yeni/kütüphane-içi siteler dahil). Yayında zayıf-GPU'lu kullanıcıları korur.

import { Text as TroikaText } from 'troika-three-text';

if (TroikaText?.prototype && !TroikaText.prototype.__sdfJsForced) {
  const origSync = TroikaText.prototype.sync;
  TroikaText.prototype.sync = function (...args) {
    this.gpuAccelerateSDF = false;
    return origSync.apply(this, args);
  };
  TroikaText.prototype.__sdfJsForced = true;
}
